module.exports = __webpack_public_path__ + "media/images/pic/groups/small/youth-ab6ee110b4311193b93c03ac5e016341.jpeg";